import { render, staticRenderFns } from "./ChooseProject.vue?vue&type=template&id=55ba76cb&scoped=true&"
var script = {}
import style0 from "./ChooseProject.vue?vue&type=style&index=0&id=55ba76cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ba76cb",
  null
  
)

export default component.exports